<template>
  <b-form-group>
    <template slot="label">
      <b-form-checkbox
        :id="`category__${category.id}`"
        v-model="category.is_all_selected"
        :indeterminate="category.indeterminate"
        aria-describedby="subCategories"
        aria-controls="subCategories"
        @change="toggleAllOptions"
      >
        {{ category.name }}
      </b-form-checkbox>
    </template>

    <div v-for="sub_category in category.sub_categories" :key="sub_category.id">
      <FilterSubCategories :sub-category="sub_category" :sub-categories-old="subCategoriesOld" />
    </div>
  </b-form-group>
</template>

<script>
import FilterSubCategories from './FilterSubCategories';

export default {
  name: 'FilterCategories',

  components: {
    FilterSubCategories
  },

  props: {
    category: {
      type: Object,
      default: () => {}
    },
    categoryIndex: {
      type: Number,
      default: null
    },
    /**
     * Track applied value
     */
    filterCategories: {
      type: Array,
      default: () => []
    },
    /**
     * Use to watch when applied => open modal => select new filter => close => open again
     */
    isModalOpenAfterApplied: {
      type: Boolean,
      default: false
    },

    subCategoriesOld: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    isAllSelected() {
      return this.category.is_all_selected;
    },
    isIndeterminate() {
      return this.category.indeterminate;
    },
    subCategoryIndex() {
      return this.category.sub_categories_name.length - 1;
    },
    subCategoryLength() {
      return this.category.sub_categories_name.length;
    },
    selectedSubCategories() {
      return this.category.sub_categories.filter(
        (sub_category) => sub_category.is_selected === true
      );
    }
  },

  watch: {
    selectedSubCategories: {
      handler(selectedSubCategories) {
        if (selectedSubCategories.length === 0) {
          this.category.indeterminate = false;
          this.category.is_all_selected = false;
        } else if (selectedSubCategories.length === this.subCategoryLength) {
          this.category.indeterminate = false;
          this.category.is_all_selected = true;
        } else {
          this.category.indeterminate = true;
          this.category.is_all_selected = false;
        }
        this.$emit('emitSelectedSubCategories', selectedSubCategories);
      }
    },

    /**
     * Receive isModalOpenAfterApplied from parent component, when modal open after applied filter and change filter
     *
     * Use to check condition of category => applied filter => select new filter => close modal (not applied) => open again
     */
    isModalOpenAfterApplied: {
      immediate: true,
      handler() {
        if (!this.filterCategories.length && !this.isModalOpenAfterApplied) return;

        if (!this.selectedSubCategories.length) {
          this.$set(this.category, 'is_all_selected', false);
          this.$set(this.category, 'indeterminate', false);
        } else if (this.subCategoryLength === this.selectedSubCategories.length) {
          this.$set(this.category, 'is_all_selected', true);
          this.$set(this.category, 'indeterminate', false);
        } else if (this.subCategoryLength !== this.selectedSubCategories.length) {
          this.$set(this.category, 'is_all_selected', false);
          this.$set(this.category, 'indeterminate', true);
        }

        this.$emit('resetIsModalOpenAfterApplied', false);
      }
    }
  },

  methods: {
    toggleAllOptions() {
      this.category.sub_categories.forEach((sub_category) => {
        if (this.isAllSelected) {
          sub_category.is_selected = false;
        } else {
          sub_category.is_selected = true;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
